import styled from "styled-components";

interface Props {
  minHeight: number,
  mobileMinHeight?: number,
}

const Wrapper = styled.div`
  width: 100%;
  background: #05D6E1;
  min-height: ${(props: Props) => props.minHeight !== 0 ? `${props.minHeight}px` : '260px'};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  z-index: 50;

  h1 {
    font-weight: bold;
    color: #333;
    text-align: center;
    line-height: 1.3;
    font-size: 1.6rem;
    margin-bottom: 10px;
  }

  a {
    font-size: 1.4rem;
    text-align: center;
    font-weight: bold;
    background: #fff;
    border: 0;
    border-radius: 60px;
    padding: 15px 30px;
    cursor: pointer;
    margin-top: 10px;

    &:hover, &:focus {
      box-shadow: 1px 5px 15px rgba(0, 0, 0, 0.2);
    }
  }

  p {
    color: #333;
    text-align: center;
    line-height: 1.3;
    font-size: 1rem;
  }

  .button-groups {
    display: flex;
    flex-direction: row;

    a:not(:last-child) {
      margin-right: 15px;
    }
  }

  @media screen and (max-width: 900px) {
    min-height: ${(props: Props) => props.mobileMinHeight ? `${props.mobileMinHeight}px` : `${props.minHeight}px`};

    .button-groups {
      flex-direction: column;

      a:not(:last-child) {
        margin-right: 0;
        margin-bottom: 10px;
      }
    }
  }

  @media screen and (max-width: 767px) {
    padding: 25px;
    min-height: ${props => props.minHeight !== 0 ? props.minHeight : '300px'};

    h1 {
      font-size: 1.4rem;
    }

    button {
      font-size: 1.2rem;
      width: 200px;
      margin-top: 20px;
    }

    .button-groups {
      flex-direction: column;
    }
  }
`;

export {
  Wrapper,
};
